module.exports = __webpack_public_path__ + "img/imagen3.942181c2.png";